import { createElementVNode as _createElementVNode, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
    ref: "editor",
    style: { "position": "absolute", "left": "0", "top": "0", "width": "100%", "height": "100%", "max-height": "100% !important", "margin": "0", "padding": "0", "overflow": "hidden" }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", _mergeProps({
        class: "border position-relative w-100 h-100",
        style: { "overflow": "hidden" }
    }, _ctx.containerAttr), [
        _createElementVNode("div", _hoisted_1, null, 512)
    ], 16));
}
